export default [ // Не менять расположение ролей, от этого зависит многий функционал
  { value: "superAdmin", label: "Супер администратор", color: "#00B8D9" },
  { value: "admin", label: "Администратор", color: "#0052CC" },
  { value: "user", label: "Пользователь", color: "#0052CC" },
];
